<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="template-page funnel-page mt-5" v-else-if="loaded" >
        
        <div class="col-12 col-md-10 offset-md-1" >            
            <div class="row no-gutters" >
                <h2 class="h2" v-if="pageType == 'add' " > Create funnel </h2>
                <h2 class="h2" v-else-if="pageType == 'edit' " > Edit funnel </h2>
            </div>      
            <div class="row no-gutters mt-3" >            

                <b-form  @submit.prevent="submit" class="atlass-form col-12 mt-md-4" >
                    
                    <div class="row w-100">
                
                        <b-alert show variant="secondary" class="w-100 mb-3" >
                            
                            All all steps from within the funnel to see journey timeline and conversion rate
                            <br>
                            <strong> Minim steps required 2</strong>: Funnel entry page with opt-in form and thank you page 
                            
                        </b-alert>  
                        
                        <b-form-input id="name"
                            type="text"
                            class="form-control mt-4 mb-4"
                            v-model="data.name"
                            style="background: #fff!important;"  
                            placeholder="Funnel name">
                        </b-form-input>
                                                
                        <div class="form-group col-12 p-0 mt-4 mb-4" v-for="(step, index) in data.steps" >
                            <label for="word" > Step {{ index + 1 }}: 
                                <span v-if="index == 0" style="text-transform: lowercase!important;" > https://domain.com/funnel-initial-page </span>
                                <span v-if="index == data.steps.length - 1" style="text-transform: lowercase!important;" > https://domain.com/funnel-thank-you-page </span>
                            </label> 
                            
                            <span class="mr-3 float-right"  > <a @click="deleteStep(step, index)" > Remove step <font-awesome-icon icon="trash-alt" /> </a> </span>
                            <!--
                            <a class="mr-3 float-right" @click="toggetStepABTEST(index)" > Toggle A/B testing <font-awesome-icon icon="trash-alt" /> </a>
                            -->
                            <span v-if="index < data.steps.length - 1" class="mr-3 float-right"  >
                                 <span  > A/B Test </span>
                                <b-form-checkbox v-model="step.ab_test" name="check-button" class="cursor-pointer d-inline-block " switch > </b-form-checkbox>
                            </span>
                                
                            
                            <!-- REGULAR -->
                            <b-form-input id="step" v-if="!step.ab_test"
                                type="text" 
                                class="form-control"
                                v-model="step.link"
                                style="background: #fff!important;"  
                                placeholder="https://domain.com/...">
                            </b-form-input>
                            
                            <div class="row mt-1" v-if="!step.ab_test" >
                                <div class="col-12 col-md-6" >
                                    <label for="word" class="d-none" > Goal </label> 
                                    Goal: 
                                    <b-form-input id="step_goal"
                                        type="text"
                                        class="form-control d-inline-block w-25"
                                        v-model="step.goal"
                                        style="background: #fff!important;"  
                                        placeholder="Goal">
                                    </b-form-input> / per day

                                </div>
                                
                                <div class="col-12 col-md-6" >
                                    Goal Type
                                    <b-form-select v-model="step.goal_type" class="form-control d-inline-block w-25" :options="goalTypeOptions"></b-form-select>
                                </div>
                                
                            </div>
                            <!-- REGULAR -->
                            
                            <!-- AB_TEST -->
                            <div class="row mt-1 ml-5" v-if="step.ab_test" >
                                
                                <b-form-input id="step" v-for="(link, i) in step.links" :key="i" v-if="step.links"
                                    type="text" 
                                    class="form-control mt-1 mb-1"
                                    v-model="link.link"
                                    style="background: #fff!important;"  
                                    placeholder="https://domain.com/...">
                                </b-form-input>
                                
                                <b-button @click="addNewStepLink(index)" variant="primary" class="btn-sm col-12 col-md-6 offset-md-3 mt-3" >Add link</b-button>
                            </div>
                            <!-- AB_TEST -->
                            
                        </div>
                            
                        <b-button @click="addNewStep" variant="primary" class="btn-sm-w mt-3" >Add step</b-button>
                        
                        
                        <b-alert show variant="secondary" class="w-100 mb-0" >
                            <strong> Conversion tags: </strong>
                            
                            <br>
                            <div class="mt-3 mb-3" style="min-height: 33px;" > 
                                <span v-if="data.conversions.length == 0" class="alert alert-primary d-block p-0 pl-5 pr-5 text-center mr-5 ml-5" style="margin-top: 5px; margin-bottom: 5px;" > No tags added yet. Add them below. </span>
                                
                                <span v-for="(t, index) in data.conversions" class="d-inline-block box-span box-span-removeable bg-color-white" style="background: #fff!important;"   > {{t}} <font-awesome-icon icon="times" @click="removeFromArray(t)" /> </span>
                            </div>

                            <label for="word" > ADD TAG: </label>
                            <b-form-input id="word" @change="addConversion"
                                type="text"
                                v-model="tag"
                                style="background: #fff!important;"  
                                placeholder="ex: $conversion">
                            </b-form-input>

                        </b-alert>    
                        
                        <div class="row col-12 ml-0 mr-0 mt-5 mb-3 p-0" >
                            <div class="p-0" :class="[{ 'col-12': pageType != 'edit'  },{ 'col-6 ': pageType == 'edit'  }]" >
                                <b-button type="submit" variant="success" class="btn-sm-w" >Save</b-button>
                            </div>
                            <div class="col-6 " v-if="pageType == 'edit'" >
                                <b-button  class="btn btn-danger btn-sm-w" @click="PreventDelete()"  > Delete </b-button >
                            </div>
                        </div>
                        
                    </div>
                    
                </b-form>
                
                
            </div>
        </div>

    </div>

</template>

<script>
import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import helper from '@/helpers/helpers.js';
    
export default {
    name: 'Funnel',
    props: {
        ID: { 
            type: [String],
        }
        
    },
    data: function(){
        return {
            data: {
                name: '',
                steps:[
                    {
                        link: "",
                        goal_type: "",
                        goal: "",
                        links: []
                    },
                    {
                        link: "",
                        goal_type: "",
                        goal: "",
                        links: []
                    },
                ],
                conversions: []
            },
            errors: [],
            loaded: false,
            pageType: 'add',
            tag: null,
            
            goalTypeOptions: [
                { value: 'visitors', text: 'Visitors' },
                { value: 'conversionRate', text: 'Conversion Rate' },
            ]
        }
    },
    ready: function (){
        
    },
    beforeCreate: function (){
        
    },
    mounted(){
        
        //console.log(this.ID)
        
        if( this.ID ){
            this.pageType = 'edit'
            this.getdata();
        }else{
            this.loaded = true
        }
    },
    created: function () {
        
    },
    beforeDestroy() {
    },
    methods: {
        getdata: function(){
            
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            var ref = db.collection('organizations/'+orgID+'/funnels').doc(this.ID)

            return ref.get()
            .then((snapshot) => {
                //console.log(snapshot.data())
                this.data = snapshot.data()
                this.loaded = true
            })
            
        },
        
        addNewStep: function(){
            this.data.steps.push( { link: "", goal: "" } )
        },
        
        addNewStepLink: function(index){
            
            this.loaded = false
            
            this.data.steps.forEach((step, i)=>{
                if( i == index ){ 
                    if( !step.links ){
                        step.links = []
                    }
                    step.links.push( { link: "", goal: "" } )
                }
            })
            
            this.loaded = true
            
        },
        
        toggetStepABTEST: function(index){
            
            this.loaded = false
            
            this.data.steps.forEach((step, i)=>{
                if( i == index ){ 
                    if( !step.ab_test ){ 
                        step.ab_test = true 
                        if( !step.links || ( step.links && step.links.length == 0 ) ){
                            step.links = []
                            step.links.push( { link: "", goal: "" } )
                        }
                        
                    }else{ 
                        step.ab_test = false 
                    }    
                    console.log(this.data)
                }
            })
            
            this.loaded = true
        },
                
        deleteStep:function(step, index){
            //console.log(index)
            
            //this.data.steps = this.data.steps.filter((item, i) => { return item } )
            let temp = []
            this.data.steps.forEach((step, i)=>{
                if( i != index ){ temp.push(step) }
            })
            this.data.steps = temp
        },

        validateSteps(){
            
            //console.log(this.data)
            
            let errors = false
            this.data.steps.forEach((step)=>{
                //console.log(step)
                if( step.link == "" ){
                    errors = true
                }
            })
            
            return errors
        },
        
        addConversion: function(){
            let tag = this.tag
            if( tag.includes('!') || tag.includes('@') ){
                this.$toast.error({
                    title:'Error',
                    message: "Only conversion tags ( starting with $ ) are accepted"
                })
            }else{
                if( !tag.includes('$') ){ tag = '$'+tag }
                this.data.conversions.push( tag )
                this.tag = ""
            }
                
        },
        
        removeFromArray: function(tag){
            this.data.conversions = this.data.conversions.filter(item => item != tag)
            /*
            console.log(tag)
            console.log( this.data.conversions )
            let conversions = this.data.conversions
            conversions = conversions.filter(item => item != tag)
            console.log( conversions )
            this.data.conversions = conversions
            */
        },
        
        submit: function(){
            
            if( this.data.name != "" && !this.validateSteps() ){
                
                this.loaded = false
                let resp = this.save()
                resp.then(function(){

                        console.log("Success")
                         this.$toast.success({
                            title:'Success',
                            message: 'Funnel saved'
                        })

                        setTimeout(function(){ 
                            this.loaded = true
                            this.$parent.$parent.get_data();
                            //console.log(this)
                            this.$parent.$parent.$parent.$parent.getFunnels();
                            this.$parent.fModalClose();
                        }.bind(this), this.imeout );



                    }.bind(this))
                    .catch(function(error){

                        //console.error("Error updating document: ", error);
                        this.$toast.error({
                            title:'Error',
                            message: "Something went wrong: "+error
                        })

                        this.loaded = true

                    }.bind(this))
            }else{
            
                this.$toast.error({
                    title:'Error',
                    message: "Plese make sure to fill out all fields: funnel name and step links"
                })
        
            }
                
            
        },
        save: function () {
            //const { firstname, lastname, website, organization, address, city, country } = this.getprofile
            let orgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
            
            const db = firebase.firestore();
            
            let document = {
                    "APPKEY": orgID,
                    "name" : this.data.name,
                    "steps": this.data.steps,
                    "conversions": this.data.conversions
                }
            
            if( this.pageType == 'add' ){

                document.datetime = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/funnels')
                
                return ref.add( document )
                
            }else{
                
                document.last_update = Math.round(+new Date()/1000)
                    
                let ref = db.collection('organizations/'+orgID+'/funnels').doc( this.ID )
                
                return ref.set( document, { merge: true } )
                
            }
            
        },
        
        PreventDelete( ){
            
            this.$parent.$parent.PreventDelete( this.ID );
            
        },        

    },
    computed: {
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

     @import '@/assets/css/variables.scss';
    
    .funnel-page .custom-switch{
        line-height: 21px;
        margin-left: 5px;
        display: inline-block;
        background-color: transparent !important;
        border-style: none !important;
        cursor: pointer;
    }
    
    .funnel-page .custom-switch:focus, 
    .funnel-page .custom-switch:active, 
    .funnel-page .custom-switch, 
    .funnel-page .custom-switch div, 
    .funnel-page .custom-switch input, 
    .funnel-page .custom-switch label, 
    .funnel-page .custom-switch *{
        outline: none!important;
        box-shadow: none!important;
        outline-color: transparent;
        outline: thin dotted;
        outline: 5px auto -webkit-focus-ring-color;
        outline-offset: -2px;
        
    }
    
    .funnel-page .custom-control-input:checked ~ .custom-control-label:before{
        background-color: #fff!important;
        border: $grayMedium solid 1px!important;
    }
    
    .funnel-page .custom-switch .custom-control-label::after{
        background-color: $grayDark!important;
    }
    
</style>



// WEBPACK FOOTER //
// src/components/funnel.vue